<template>
<div class="media-query-helper">
  <h1 v-for="(label, name) in screens"
      class="media-query-helper-heading"
      :class="`media-query-helper-heading-${name}`"
  >
    {{ label }}
  </h1>
</div>
</template>

<script>
export default {
  data() {
    return {
      screens: {
        sm: 'SM',
        md: 'MD',
        lg: 'LG',
        xl: 'XL',
        xxl: 'XXL',
        xxxl: 'XXXL',
      },
    }
  }
}
</script>

<style lang="less">
.media-query-helper {
  @apply fixed p-4 bg-danger-light;
  top: 65px;
  right: 15px;

  .media-query-helper-heading {
    @apply font-bold text-sm text-white;
    &.media-query-helper-heading-md,
    &.media-query-helper-heading-lg,
    &.media-query-helper-heading-xl,
    &.media-query-helper-heading-xxl,
    &.media-query-helper-heading-xxxl {
      @apply hidden;
    }
  }
}

@screen md {
  .media-query-helper {
    .media-query-helper-heading {
      &.media-query-helper-heading-sm,
      &.media-query-helper-heading-lg,
      &.media-query-helper-heading-xl,
      &.media-query-helper-heading-xxl,
      &.media-query-helper-heading-xxxl {
        @apply hidden;
      }

      &.media-query-helper-heading-md {
        @apply block;
      }
    }
  }
}

@screen lg {
  .media-query-helper {
    .media-query-helper-heading {
      &.media-query-helper-heading-sm,
      &.media-query-helper-heading-md,
      &.media-query-helper-heading-xl,
      &.media-query-helper-heading-xxl,
      &.media-query-helper-heading-xxxl {
        @apply hidden;
      }

      &.media-query-helper-heading-lg {
        @apply block;
      }
    }
  }
}

@screen xl {
  .media-query-helper {
    .media-query-helper-heading {
      &.media-query-helper-heading-sm,
      &.media-query-helper-heading-md,
      &.media-query-helper-heading-lg,
      &.media-query-helper-heading-xxl,
      &.media-query-helper-heading-xxxl {
        @apply hidden;
      }

      &.media-query-helper-heading-xl {
        @apply block;
      }
    }
  }
}

@screen xxl {
  .media-query-helper {
    .media-query-helper-heading {
      &.media-query-helper-heading-sm,
      &.media-query-helper-heading-md,
      &.media-query-helper-heading-lg,
      &.media-query-helper-heading-xl,
      &.media-query-helper-heading-xxxl {
        @apply hidden;
      }

      &.media-query-helper-heading-xxl {
        @apply block;
      }
    }
  }
}

@screen xxxl {
  .media-query-helper {
    .media-query-helper-heading {
      &.media-query-helper-heading-sm,
      &.media-query-helper-heading-md,
      &.media-query-helper-heading-lg,
      &.media-query-helper-heading-xl,
      &.media-query-helper-heading-xxl {
        @apply hidden;
      }

      &.media-query-helper-heading-xxxl {
        @apply block;
      }
    }
  }
}
</style>
